module.exports = __webpack_public_path__ + "media/images/teams/logo__7-db5d3b537019edeb19c7d0ecb73826cd.svg";